import React from 'react';
import { Field } from 'redux-form';
import { InputField } from '../../inputs/standard';
import Calendar from '../../components/Calendar';

export const FormField = ({ id, name, disabled, label }) => (
    <div className="form-row mb-2">
        <label htmlFor={id} className={'blue small col-4 mb-0'}>
            {label}
        </label>
        <div className="col">
            <Field
                component={InputField}
                name={name}
                type="text"
                className="form-control"
                id={id}
                disabled={disabled}
            />
        </div>
    </div>
);

export const FormSelect = ({ id, name, label, list, ...props }) => (
    <div className="form-row mb-2">
        <label htmlFor={id} className="blue small col-4 mb-0">
            {label}
        </label>
        <div className="col">
            <Field id={id} name={name} component={'select'} className={'form-control'} {...props}>
                {list.map(item => (
                    <option key={item.key || item.value} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </Field>
        </div>
    </div>
);

export const FormRadio = ({ id, name, label, options }) => (
    <div className="form-row mb-2">
        <label htmlFor={id} className={'blue small col-4 mb-0 align-self-start line30'}>
            {label}
        </label>
        <div className="col">
            {options.map(option => (
                <label className="d-flex flex-row justify-content-start mb-0" key={option.value}>
                    <Field
                        name={name}
                        component="input"
                        type="radio"
                        value={option.value}
                        className="mt-auto mb-auto mr-2"
                        disabled
                    />
                    {option.label}
                </label>
            ))}
        </div>
    </div>
);

export const FormDate = ({ label }) => (
    <div className="form-row mb-2">
        <label htmlFor="birth-date" className="blue small col-4 mb-0">
            {label}
        </label>
        <div className="col">
            <Field
                name="birthDate"
                disableFuture
                isUsFormat={window.VULOG_CONFIG && window.VULOG_CONFIG.US_DATE_FORMAT}
                component={Calendar}
                disabled
            />
        </div>
    </div>
);
